/**
 * Auth Command - Simple token management
 */

import { Command } from 'commander';
import * as fs from 'fs';
import * as path from 'path';
import { colors, icons } from '../ui/theme';

export function registerAuth(program: Command): void {
  const auth = program
    .command('auth')
    .description('Authentication commands (optional)');

  auth
    .command('login')
    .description('Save API token (optional - CLI works without auth)')
    .argument('<token>', 'API token from https://app.vibecheckai.dev')
    .action((token: string) => {
      try {
        const vibecheckDir = path.join(require('os').homedir(), '.vibecheck');
        if (!fs.existsSync(vibecheckDir)) {
          fs.mkdirSync(vibecheckDir, { recursive: true });
        }
        
        const tokenPath = path.join(vibecheckDir, 'token');
        fs.writeFileSync(tokenPath, token.trim());
        
        console.log(colors.success(`${icons.success} Token saved successfully!`));
        console.log(colors.dim('  CLI is now ready to use.'));
      } catch (error) {
        console.error(colors.error(`${icons.error} Failed to save token: ${error}`));
        process.exit(1);
      }
    });

  auth
    .command('logout')
    .description('Remove saved token')
    .action(() => {
      try {
        const tokenPath = path.join(require('os').homedir(), '.vibecheck', 'token');
        if (fs.existsSync(tokenPath)) {
          fs.unlinkSync(tokenPath);
          console.log(colors.success(`${icons.success} Token removed successfully!`));
        } else {
          console.log(colors.dim('  No token found.'));
        }
      } catch (error) {
        console.error(colors.error(`${icons.error} Failed to remove token: ${error}`));
        process.exit(1);
      }
    });

  // Add alias 'login' -> 'auth login'
  program
    .command('login')
    .description('Save API token (optional)')
    .argument('<token>', 'API token from https://app.vibecheckai.dev')
    .action((token: string) => {
      // Reuse auth login logic
      const tokenPath = path.join(require('os').homedir(), '.vibecheck', 'token');
      const vibecheckDir = path.dirname(tokenPath);
      if (!fs.existsSync(vibecheckDir)) {
        fs.mkdirSync(vibecheckDir, { recursive: true });
      }
      fs.writeFileSync(tokenPath, token.trim());
      console.log(colors.success(`${icons.success} Token saved successfully!`));
    });
}
